import styled from "styled-components";

export const MainContentsItem = styled.li`
  padding: 20px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadow.box};
`;

export const NodataItemBox = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.placeholderTxt};
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    display: flex;
    height: 120px;
    font-size: 1.4rem;
    align-items: center;
    justify-content: center;
  }
`;

export const DataItemBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 15px;
`;

export const DataHeadBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  & > div {
    display: flex;
    padding-left: 5px;
    font-size: 1.4rem;
    font-weight: 600;
    align-items: center;
    gap: 6px;
  }
`;

export const DataRouteBox = styled.div`
  /* display: grid;
  margin: 14px 0;
  padding: 15px 0;
  background: ${(props) => props.theme.colors.mainBg};
  border-radius: 10px;
  grid-template-columns: 1fr 10px 1fr 10px 1fr;
  align-items: center;
  justify-content: center;
  white-space: pre-line;
  text-align: center; */
  display: flex;
  flex-direction: column;
  padding: 15px;
  background: ${(props) => props.theme.colors.mainBg};
  gap: 9px;
`;

export const DataRouteBoxHead = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 410px) {
    white-space: nowrap;
  }
`;

export const DataRouteHeadTopBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const DataRouteStepText = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.homeStepBg};
`;

export const DataRouteStep = styled.div`
  border-radius: 6px;
  padding: 3px 6px;
  background: ${(props) => props.theme.colors.homeStepBg};
  font-size: 1.4rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.white};
`;

export const DataRouteHeadBottomDateText = styled.span`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.contentLabelTxt};
  text-align: end;
`;

export const ProgressBarBox = styled.div`
  width: 100%;
  height: 12px;
  position: relative;
  background: ${(props) => props.theme.colors.white};
  border-radius: 12px;
`;

export const ProgressBar = styled.div<any>`
  width: ${(props) =>
    props.width === "LOADING_COMPLETED"
      ? "34%"
      : props.width === "EN_ROUTE_TO_WORK_POINT"
      ? "51%"
      : props.width === "WORK_COMPLETED"
      ? "68%"
      : props.width === "EN_ROUTE_TO_UNLOADING_POINT"
      ? "85%"
      : props.width === "UNLOADING_COMPLETED"
      ? "100%"
      : props.width === "TRANSPORTATION_CANCEL_REQUEST"
      ? "0%"
      : "17%"};
  height: 9px;
  position: absolute;
  top: 50%;
  left: 0;
  background: ${(props) => props.theme.colors.homeStepBg};
  transform: translate(0, -50%);
  border-radius: 12px;
`;

export const DataRouteBottomBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  p {
    font-size: 1.5rem;
    font-weight: 600;
  }
`;

export const DataListBox = styled.div`
  /* display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-content: center;
  gap: 5px; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const DataListBottomBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const DataListText = styled.p`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.contentLabelTxt};

  &.contentText {
    color: ${(props) => props.theme.colors.black};
    font-size: 1.6rem;
    font-weight: 500;
  }
`;

export const MatchButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  bottom: 0;
  gap: 10px;

  button:first-child {
    flex: 1;
  }

  button:last-child {
    flex: 3;
  }
`;

export const DetailRouteBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  div {
    font-size: 1.5rem;
    font-weight: 600;
  }
`;
